import React from 'react';
import i18n from 'i18next';
import dayjs from 'dayjs';
import { css } from '@emotion/core';
import Typography from '@material-ui/core/Typography';

import { utcDTStr2UTC, utcDTStr2LocalDTStr } from 'utils/dateTime';
import { error } from 'Mui/styles/color';
import { prizeRedeemDateLimitTypes } from 'config/promoPrizeTypes';
import getPrizeRedeemWithinEndUtc, {
    getPrizeRedeemWithinMonthEndUtc
} from 'client/utils/getPrizeRedeemWithinEndUtc';

function PrizeRedeemDeadline({
    style,
    hasEnableRedeemForm,
    hasFillRedeemForm,
    fillFormEndDate,
    redeemTimeType,
    redeemStartDate,
    redeemEndDate,
    redeemWithinDateTime,
    redeemWithinMonthsLastDay,
    winnerCreatedAt,
    redeemWithinDays
}) {
    if (hasEnableRedeemForm && !hasFillRedeemForm) {
        return !fillFormEndDate ? null : (
            <Typography css={css(style)} variant="subtitle2">
                {i18n.t('label.fill_date_deadline')}
                {utcDTStr2LocalDTStr(fillFormEndDate, 'YYYY-MM-DD HH:mm')}
            </Typography>
        );
    }
    if (redeemTimeType === prizeRedeemDateLimitTypes.RANGE && redeemStartDate && redeemEndDate) {
        // 指定時間區段
        const startDateUtc = utcDTStr2UTC(redeemStartDate);
        const endDateUtc = utcDTStr2UTC(redeemEndDate);
        const hasNotStartRedeem = dayjs().isBefore(dayjs(startDateUtc));

        return (
            <Typography css={css(style)} variant="subtitle2">
                {i18n.t('label.redeem_date')}
                {hasNotStartRedeem ? (
                    <span css={css(`color: ${error.color};`)}>
                        {i18n.t('label.redeem_date.has_not_start')}
                    </span>
                ) : (
                    dayjs(endDateUtc).format('YYYY-MM-DD HH:mm')
                )}
            </Typography>
        );
    }
    if (redeemTimeType === prizeRedeemDateLimitTypes.WITHIN && redeemWithinDays) {
        // 配獎後幾天到期
        const startDateUtc = utcDTStr2UTC(winnerCreatedAt);
        const endDateUtc = getPrizeRedeemWithinEndUtc(winnerCreatedAt, redeemWithinDays);
        const hasNotStartRedeem = dayjs().isBefore(dayjs(startDateUtc));

        return (
            <Typography css={css(style)} variant="subtitle2">
                {i18n.t('label.redeem_date')}
                {hasNotStartRedeem ? (
                    <span css={css(`color: ${error.color};`)}>
                        {i18n.t('label.redeem_date.has_not_start')}
                    </span>
                ) : (
                    dayjs(endDateUtc).format('YYYY-MM-DD HH:mm')
                )}
            </Typography>
        );
    }

    if (
        redeemTimeType === prizeRedeemDateLimitTypes.WITHIN_MONTH_LAST_DAY &&
        redeemWithinMonthsLastDay
    ) {
        // 配獎後月底到期
        const startDateUtc = utcDTStr2UTC(winnerCreatedAt);
        const endDateUtc = getPrizeRedeemWithinMonthEndUtc(
            winnerCreatedAt,
            redeemWithinMonthsLastDay
        );
        const hasNotStartRedeem = dayjs().isBefore(dayjs(startDateUtc));

        return (
            <Typography css={css(style)} variant="subtitle2">
                {i18n.t('label.redeem_date')}
                {hasNotStartRedeem ? (
                    <span css={css(`color: ${error.color};`)}>
                        {i18n.t('label.redeem_date.has_not_start')}
                    </span>
                ) : (
                    dayjs(endDateUtc).format('YYYY-MM-DD HH:mm')
                )}
            </Typography>
        );
    }

    if (redeemTimeType === prizeRedeemDateLimitTypes.FIXED_EXPIRATION && redeemWithinDateTime) {
        // 固定到期日
        const startDateUtc = utcDTStr2UTC(winnerCreatedAt);
        const endDateUtc = utcDTStr2UTC(redeemWithinDateTime);
        const hasNotStartRedeem = dayjs().isBefore(dayjs(startDateUtc));

        return (
            <Typography css={css(style)} variant="subtitle2">
                {i18n.t('label.redeem_date')}
                {hasNotStartRedeem ? (
                    <span css={css(`color: ${error.color};`)}>
                        {i18n.t('label.redeem_date.has_not_start')}
                    </span>
                ) : (
                    dayjs(endDateUtc).format('YYYY-MM-DD HH:mm')
                )}
            </Typography>
        );
    }
    return null;
}

export default PrizeRedeemDeadline;
